module.exports = __webpack_public_path__ + "img/Iconset_DGBRT--22.946f33a4.png";